import { render, staticRenderFns } from "./ConsultAppointmentsPage.vue?vue&type=template&id=2040360e"
import script from "./ConsultAppointmentsPage.vue?vue&type=script&lang=ts"
export * from "./ConsultAppointmentsPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultAppointmentsPage.vue?vue&type=style&index=0&id=2040360e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports